"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToastMessages = void 0;
var react_1 = require("react");
function useToastMessages() {
    var _a = react_1.useState([]), toastMessages = _a[0], setToastMessages = _a[1];
    var removeToast = function (id) {
        setToastMessages(function (prevToasts) { return prevToasts.filter(function (toast) { return toast.id !== id; }); });
    };
    var showToast = function (props) {
        var message = props.message, _a = props.newToast, newToast = _a === void 0 ? false : _a, title = props.title, buttonLabel = props.buttonLabel, action = props.action, _b = props.secondsVisible, secondsVisible = _b === void 0 ? 5 : _b, onClose = props.onClose;
        var toast = {
            id: Date.now(),
            message: message,
            action: action,
            title: title,
            newToast: newToast,
            buttonLabel: buttonLabel,
            removeToast: removeToast,
            secondsVisible: secondsVisible,
            onClose: onClose,
        };
        setToastMessages(function (prevToasts) { return __spreadArrays(prevToasts, [toast]); });
    };
    return { toastMessages: toastMessages, setToastMessages: setToastMessages, showToast: showToast };
}
exports.useToastMessages = useToastMessages;
//# sourceMappingURL=useToastMessages.js.map